module.exports = __webpack_public_path__ + "static/media/logos.901013fd.png";